import {CLEAR_SHIFT_DAYS} from "../../../enums/Request/request.types";

export const clearShiftDaysAction = () => {
    return {
        type: CLEAR_SHIFT_DAYS,
    };
};
